import SVGCard from './SVGCard'

const HandDisplay = {

  init: ()=>{},

  changeCard: function (cardOld, cardNew) {
    const svg = HandDisplay.cardSvg(cardNew)
    // should b 1 and only 1 match for this card, unless it is the back, if so, do the first one
    return $(`.hand svg.card-${cardOld}:first`).replaceWith(svg)
  },
  clear: function () {
    const svg = HandDisplay.cardSvg("0b")
    $('.hand svg').replaceWith(svg)
  },
  cardSvg: function (card) {
    const [rank, suit] = card
    return SVGCard.mini.byRankSuit(rank, suit)
  },
  card: function (i) {  // HandDisplay.card(i).toggleBest(t/f)
    this.toggleBest = function (v) {
      const svg = $('.hand svg')[i]
      v ? $(svg).addClass('best') : $(svg).removeClass('best')
    }
    return this
  },
  showBest: function () {
    $('div#best').show();
    const best = machine.game.bestEV()
    best.holdBitCodeL2R.map((h, i) => HandDisplay.card(i).toggleBest(h == 1))
  },
  hideBest: function () {
    $('div#best').hide()
    $('.hand svg').removeClass('best')
  }

}

export default HandDisplay